import React, { memo, useMemo } from "react";
import { settings_sidebar_tabs } from "../settings_constants";
import { useGroupChatContext } from "../../../../context/groupchatContext";

function SettingsSideBar({ activeTab = "", setActiveTab = () => {}, variant = "vertical" }) {
  const groupChatContext = useGroupChatContext();

  const { authData } = useMemo(() => ({
    authData: groupChatContext.authData,
  }));

  const shouldShowTab = (tab) => {
    return tab?.show?.some((role) => {
      if (role === "provider") return !!authData?.is_provider;
      if (role === "nurse") return !authData?.is_provider;
      if (role === "nurse_admin") return !authData?.is_provider && !!authData?.is_facility_admin;
      return false;
    });
  };

  const isHorizontal = variant === "horizontal";
  const filteredTabs = useMemo(
    () => settings_sidebar_tabs.filter((tab) => shouldShowTab(tab)),
    [authData?.is_provider, authData?.is_facility_admin]
  );

  return (
    <ul
      className={
        isHorizontal
          ? "flex flex-row items-stretch gap-0 overflow-x-auto overflow-y-hidden w-full min-h-0 border-b border-gray-200 bg-white shadow-sm shrink-0"
          : "w-full h-[calc(100vh-65px)] md:h-[calc(100vh-4rem)] border-r border-gray-200 bg-white shadow-sm flex flex-col shrink-0"
      }
    >
      {filteredTabs.map((tab) => (
        <li
          className={
            isHorizontal
              ? `flex items-center justify-center gap-2 cursor-pointer px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                  activeTab === tab?.slug
                    ? `${authData?.is_provider ? 'border-teal-500 text-teal-500 bg-teal-50/80' : 'border-violet-600 text-violet-700 bg-violet-50/80'}`
                    : "border-transparent text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                }`
              : `flex items-center h-12 min-h-[3rem] text-sm w-full cursor-pointer gap-3 px-4 border-b border-gray-100 last:border-b-0 transition-colors ${
                  activeTab === tab?.slug
                  ? `${authData?.is_provider ? 'bg-teal-50 text-teal-500 border-l-4 border-l-teal-500 font-medium' : 'bg-violet-50 text-violet-800 border-l-4 border-l-violet-600 font-medium'}`
                    : "text-gray-700 hover:bg-gray-50"
                }`
          }
          key={tab?.id}
          onClick={() => setActiveTab(tab?.slug)}
        >
          {tab?.icon}
          {tab?.title}
        </li>
      ))}
    </ul>
  );
}

export default memo(SettingsSideBar);
